import React from 'react';
import {Link} from 'react-router-dom';

export class HWGCashPanel extends React.Component {
    render(){
        
        return (
            <section className="section main-container hwgcash">
                <div className=" columns">
                    <div className="column is-12 has-text-centered">
                                <div className="btnHwgcash">
                                    <Link to="/hwgcash">
                                        <button className="button is-primary is-outlined">
                                            Get Your HWG Cash Now
                                        </button>
                                    </Link>
                                </div>
                    </div>
                </div>
            
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Views/HomePage/HWGCashPanel.jsx